import React from 'react';
import type { IconProps } from '../types';

export const IconBadge: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M10 2.5L12.2361 6.94095L17.1803 7.52786L13.59 10.809L14.4721 15.7221L10 13.5L5.52786 15.7221L6.41 10.809L2.81966 7.52786L7.76393 6.94095L10 2.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

